import {
  OBTER_TELAS_DISPONIVEIS_SUCCESS,
  RESETA_TELAS_DISPONIVEIS_REQUEST,
} from './constants';

const initialState = {
  grafico_rendimento: false,
  extrato_conta_ativo: false,
  tabela_contribuicao: false,
  percentual_contribuicao: false,
  relatorio_contribuicao: false,
  aporte: false,
  segunda_via_boleto: false,
  att_dados_cadastrais: false,
  incluir_excluir_dependente: false,
  incluir_excluir_beneficiario: false,
  simular_beneficio: false,
  contracheque: false,
  informe_rendimento: false,
  abono_anual: false,
  simular_emprestimo: false,
  contratos_aberto: false,
  cpa: false,
  comunicacao_plano: false,
  extrato_cnpc: false,
  reserva_matematica: false,
  migracao_reserva: false,
  regime_tributacao: false,
  questionario_investidor: false,
  alterar_perfil: false,
  historico_perfil: false,
  memoria_calculo: false,
  extrato_aposentadoria: false,
  extrato_opcao: false,
  parcela_adicional: false,
  saque_vista: false,
  transformacao_reserva: false,
  simular_conversao_beneficio: false,
  alterar_recebimento: false,
  notificacao_participante: false,
  transformacao_reserva_planoA: false,
  saude_financeira: false,
  resgate_parcial: false,
  extrato_pensionista_assistido: false,
  bloqueio_att_email: false,
};

// eslint-disable-next-line default-param-last
export default function telasDisponiveis(state = initialState, action) {
  switch (action.type) {
    case OBTER_TELAS_DISPONIVEIS_SUCCESS: {
      const stateWithActiveTrue = (action.payload || []).reduce(
        (prev, curr) => {
          if (initialState[curr] !== undefined) {
            return {
              ...prev,
              [curr]: true,
            };
          }

          return prev;
        },
        initialState
      );

      return {
        ...stateWithActiveTrue,
      };
    }
    case RESETA_TELAS_DISPONIVEIS_REQUEST: {
      return initialState;
    }

    default:
      return state;
  }
}
